export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/SouthAfrica-e2dafad682a3dba63f8edc87783d8386.mp3";